import React from "react";
import { useState, useEffect } from "react"
import "./OrderProgressCard.css";
import _ from "lodash";

import { ReactComponent as PendingIcon } from "../../assets/image/svg/pendingIcon.svg";
import { ReactComponent as Confirmedcon } from "../../assets/image/svg/confirmIcon.svg";
import { ReactComponent as InvoicedIcon } from "../../assets/image/svg/invoicedIcon.svg";

interface OrderTrackingProps {
  status: string;
  trackingStagesList: any[]
  stages: Record<string, number>,
  insideManageInvoice?: boolean,
}

const OrderProgressCard: React.FC<OrderTrackingProps> = ({
  status,
  trackingStagesList,
  stages,
  insideManageInvoice
}) => {

  const [stagesConfig, setStagesConfig] = useState<any>({})

  const fillColorUptoNumber = stages?.[status] ?? -Infinity

  useEffect(() => {
    const updatedStagesColors = trackingStagesList?.reduce((acc: any, curr: any) => {
      const { id, dmsLabelColor, dmsColor, dmsLabel } = curr ?? {}

      const fillWithColor: boolean = (stages?.[id] ?? +Infinity) <= fillColorUptoNumber

      if (!acc?.[id]) {
        acc[id] = { styles: {}, label: {} };
      }

      acc[id].styles = {
        color: fillWithColor ? (dmsLabelColor ?? "#7c7c7c") : "#7c7c7c",
        borderColor: fillWithColor ? (dmsLabelColor ?? "#B9B9B9") : "#B9B9B9",
        backgroundColor: fillWithColor ? (dmsColor ?? "#fff") : "#fff",
      }

      acc[id].addInfo = { label: dmsLabel }

      return acc
    }, {})

    setStagesConfig(updatedStagesColors)
  }, [status, trackingStagesList])


  const getIcon = (stage: string) => {
    switch (stage) {
      case "PENDING":
        return <PendingIcon />;
      case "CONFIRMED":
        return <Confirmedcon />;
      case "INVOICED":
        return <InvoicedIcon />;
      default:
        return <></>;
    }
  };


  const getStageStyles = (stage: string) => {
    if (status?.toUpperCase() === "REJECTED" && stage?.toUpperCase() === "PENDING" && !insideManageInvoice){ return {
      color: "#B54747",
      borderColor: "#B54747",
      backgroundColor: "#FFF1F1"
    }} else if (status?.toUpperCase() === "REJECTED" && stage?.toUpperCase() === "INVOICED" && insideManageInvoice) {return {
      color: "#B54747",
      borderColor: "#B54747",
      backgroundColor: "#FFF1F1"
    }}
    const { color, borderColor, backgroundColor } = stagesConfig?.[stage]?.styles ?? {}

    return {
      color,
      borderColor,
      backgroundColor
    };
  };

  const getStageLabel = (stage: string) => {
    const { label } = stagesConfig?.[stage]?.addInfo ?? {}
    return label
  }


  return (
    <div className="OrderTrackingContainer">
      {Object.keys(stages)?.map((stage: string, idx: number, arr: any) => {
        return (
          <div key={stage} className="OrderTracking_stageContainer">
            <div className="OrderTracking_stageNameContainer">
              <div style={getStageStyles(stage)}>{getIcon(stage)}</div>
              <span style={{ color: getStageStyles(stage)?.color }}>{_.capitalize(getStageLabel(stage))}</span>
            </div>
            {idx < arr?.length - 1 && <span className="OrderTracking_stageSeperator">------</span>}
          </div>
        );
      })}
    </div>
  );
};

export default OrderProgressCard;
